// features/candidates/actions.js
export const FETCH_CANDIDATES_REQUEST = 'FETCH_CANDIDATES_REQUEST'
export const FETCH_CANDIDATES_SUCCESS = 'FETCH_CANDIDATES_SUCCESS'
export const FETCH_CANDIDATES_FAILURE = 'FETCH_CANDIDATES_FAILURE'

export const SEARCH_QUERY_REQUEST = 'SEARCH_QUERY_REQUEST'
export const SEARCH_QUERY_SUCCESS = 'SEARCH_QUERY_SUCCESS'
export const SEARCH_QUERY_FAILURE = 'SEARCH_QUERY_FAILURE'

// features/candidates/actions.js
export const ADVANCE_SEARCH_REQUEST = 'ADVANCE_SEARCH_REQUEST'
export const ADVANCE_SEARCH_SUCCESS = 'ADVANCE_SEARCH_SUCCESS'
export const ADVANCE_SEARCH_FAILURE = 'ADVANCE_SEARCH_FAILURE'

// Action creators
export const fetchCandidatesRequest = () => ({
  type: FETCH_CANDIDATES_REQUEST
})

export const fetchCandidatesSuccess = candidates => ({
  type: FETCH_CANDIDATES_SUCCESS,
  payload: candidates
})

export const fetchCandidatesFailure = error => ({
  type: FETCH_CANDIDATES_FAILURE,
  payload: error
})

// Thunk action to fetch candidates
export const fetchAllCandidates = (page, tenant) => {
  return async dispatch => {
    dispatch(fetchCandidatesRequest())
    try {
      const token = localStorage.getItem('token')
      localStorage.removeItem('search')
      const response = await fetch(
        `${tenant.getApiUrl('candidates')}?page=${page || 1}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        }
      )
      if (!response.ok) {
        throw new Error('Failed to fetch candidates')
      }
      const data = await response.json()
      dispatch(fetchCandidatesSuccess(data.products || []))
    } catch (error) {
      dispatch(fetchCandidatesFailure(error.message))
    }
  }
}

// Action creators for advanced search
export const advanceSearchRequest = () => ({
  type: ADVANCE_SEARCH_REQUEST
})

export const advanceSearchSuccess = results => ({
  type: ADVANCE_SEARCH_SUCCESS,
  payload: results
})

export const advanceSearchFailure = error => ({
  type: ADVANCE_SEARCH_FAILURE,
  payload: error
})

// Thunk action for advanced search
export const performAdvanceSearch = (page, tenant) => {
  return async dispatch => {
    dispatch(advanceSearchRequest())
    try {
      const search = JSON.parse(localStorage.getItem('search'))
      const token = localStorage.getItem('token')
      const response = await fetch(
        `${tenant.getApiUrl('candidate')}?page=${page}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify(search)
        }
      )
      if (!response.ok) {
        throw new Error('Failed to perform advanced search')
      }
      const data = await response.json()
      dispatch(advanceSearchSuccess({ results: data.response || [], page: page }))
    } catch (error) {
      dispatch(advanceSearchFailure(error.message))
    }
  }
}

export const searchQueryRequest = () => ({
  type: SEARCH_QUERY_REQUEST
})

export const searchQuerySuccess = results => ({
  type: SEARCH_QUERY_SUCCESS,
  payload: results
})

export const searchQueryFailure = error => ({
  type: SEARCH_QUERY_FAILURE,
  payload: error
})

export const performSearchQuery = tenant => {
  return async dispatch => {
    dispatch(searchQueryRequest())
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('query')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok) {
        throw new Error('Failed to perform advanced search')
      }
      const data = await response.json()
      dispatch(searchQuerySuccess(data.res || []))
    } catch (error) {
      dispatch(searchQueryFailure(error.message))
    }
  }
}

// Action Types
export const GET_KEYWORDS_REQUEST = 'GET_KEYWORDS_REQUEST'
export const GET_KEYWORDS_SUCCESS = 'GET_KEYWORDS_SUCCESS'
export const GET_KEYWORDS_FAILURE = 'GET_KEYWORDS_FAILURE'

export const GET_LOCATIONS_REQUEST = 'GET_LOCATIONS_REQUEST'
export const GET_LOCATIONS_SUCCESS = 'GET_LOCATIONS_SUCCESS'
export const GET_LOCATIONS_FAILURE = 'GET_LOCATIONS_FAILURE'

export const GET_PROFILES_REQUEST = 'GET_PROFILES_REQUEST'
export const GET_PROFILES_SUCCESS = 'GET_PROFILES_SUCCESS'
export const GET_PROFILES_FAILURE = 'GET_PROFILES_FAILURE'

// Action Creators
export const getAllKeywords = tenant => {
  return async dispatch => {
    dispatch({ type: GET_KEYWORDS_REQUEST })
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('keyword')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok) {
        throw new Error('Failed to retrieve keywords')
      }
      const data = await response.json()
      dispatch({ type: GET_KEYWORDS_SUCCESS, payload: data.data || [] })
    } catch (error) {
      dispatch({ type: GET_KEYWORDS_FAILURE, payload: error.message })
    }
  }
}

export const getAllLocations = tenant => {
  return async dispatch => {
    dispatch({ type: GET_LOCATIONS_REQUEST })
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('location')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok) {
        throw new Error('Failed to retrieve locations')
      }
      const data = await response.json()
      dispatch({ type: GET_LOCATIONS_SUCCESS, payload: data.data || [] })
    } catch (error) {
      dispatch({ type: GET_LOCATIONS_FAILURE, payload: error.message })
    }
  }
}

export const getAllProfiles = tenant => {
  return async dispatch => {
    dispatch({ type: GET_PROFILES_REQUEST })
    try {
      const token = localStorage.getItem('token')
      const response = await fetch(`${tenant.getApiUrl('jobProfile')}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok) {
        throw new Error('Failed to retrieve profiles')
      }
      const data = await response.json()
      
      dispatch({ type: GET_PROFILES_SUCCESS, payload: data.response || [] })
    } catch (error) {
      dispatch({ type: GET_PROFILES_FAILURE, payload: error.message })
    }
  }
}

// Action to remove a candidate from list after stage change
export const REMOVE_CANDIDATE_FROM_LIST = 'REMOVE_CANDIDATE_FROM_LIST'

export const removeCandidateFromList = candidateId => ({
  type: REMOVE_CANDIDATE_FROM_LIST,
  payload: candidateId
})

export const deleteCandidate = (tenant, id) => {
  try {
    const token = localStorage.getItem('token')
    fetch(`${tenant.getApiUrl('candidate')}/delete?id=${id}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(res => console.log(res))
  } catch (e) {
    console.log(e)
  }
}
